import Nullstack from 'nullstack';
export default function IconBoxAlignTopLeft({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-box-align-top-left",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M11.005 5.005v5a1 1 0 0 1 -1 1h-5a1 1 0 0 1 -1 -1v-5a1 1 0 0 1 1 -1h5a1 1 0 0 1 1 1z"
  }), "   ", Nullstack.element("path", {
    d: "M15.005 4.005h-.01"
  }), "   ", Nullstack.element("path", {
    d: "M20.005 4.005h-.01"
  }), "   ", Nullstack.element("path", {
    d: "M20.005 9.005h-.01"
  }), "   ", Nullstack.element("path", {
    d: "M20.005 15.005h-.01"
  }), "   ", Nullstack.element("path", {
    d: "M4.005 15.005h-.01"
  }), "   ", Nullstack.element("path", {
    d: "M20.005 20.005h-.01"
  }), "   ", Nullstack.element("path", {
    d: "M15.005 20.005h-.01"
  }), "   ", Nullstack.element("path", {
    d: "M9.005 20.005h-.01"
  }), "   ", Nullstack.element("path", {
    d: "M4.005 20.005h-.01"
  }), " ");
}